<template>
  <div>

    <div>

        <steps-bar class="mb-3 d-flex d-md-none"></steps-bar>

        <order-row v-for="(row, index) in customband.customization.rows" :key="index" :row="row" :position="index"></order-row>

        <order-row :row="lastRow" :position="lastRowIndex + 1" :is-preview="true"></order-row>

        <div class="row rowspace extra-fees-row" v-if="customband.getPrintedExtraColorPrice() > 0">
        <div class="col-md-10 text-right"><span class="price-label">Fee for Extra Colors <small>({{ customband.numberOfExtraPrintColors() }} @ ${{ customband.printedExtraColorFee | currency }})</small></span></div>
        <div class="col-md-2 text-right"><span class="price-value">{{ customband.getPrintedExtraColorPrice() | currency }}</span></div>
        </div>

        <div class="row justify-content-end align-items-center mb-4">
            <div class="col-auto">
                <v-tooltip top>
<!--                    <button id="add-another-item" class="btn btn-outline-primary" @click="addRow()" slot="activator">Add Item</button>-->
                    <span>Add another size or color</span>
                </v-tooltip>
            </div>
            <div class="col-auto">
                <add-to-cart v-if="customband.template === 'fixed'" class="force-right" stage="stage" display-alert="displayAlert" display-warning="displayWarning"></add-to-cart>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <div class="mb-4">
                    <p v-if="manifestNotes">{{ manifestNotes }}</p>
                    <textarea class="form-control" placeholder="Notes to Customer Service" v-model="customband.customization.notes"></textarea>
                </div>
            </div>
        </div>

    </div>



  </div>
</template>

<style lang="scss">

</style>

<script>
  import { mapState } from 'vuex'
  import _get from 'lodash/get'

  let stateName = 'bandbuilder.silicone.style'

  export default {
    data () {
      return {
        colorFillDays: parseInt(window.RB.color_fill_days),
        colorFillExtraDayQtyThreshold: parseInt(window.RB.colorfill_extra_day_qty_threshold)
      }
    },
    computed: {

      realColorFillDays () {
        return this.customband.getTotalQuantity() > this.colorFillExtraDayQtyThreshold ? this.colorFillDays + 1 : this.colorFillDays
      },

      manifestNotes () {
        return _get(this.customband, 'product.manifest.notes.text', '')
      },

      ...mapState([
        // map this.customband to store.state.customband
        'customband',
        'customstates'
      ]),

      lastRowIndex () {
        return this.customband.customization.rows.length - 1
      },

      lastRow () {
        return this.customband.customization.rows[this.lastRowIndex]
      },
    },
    methods: {
      addRow () {
        this.$store.commit('customband/addRow')
        this.$root.$data.fixedPreview.renderProduct()
      }
    },
    created () {
      this.$store.dispatch('customstates/stepIsVisited', stateName)
      this.$store.dispatch('customband/checkCompletion')
    }
  }
</script>
